module.exports = __webpack_public_path__ + "static/media/05.2db9ca20.jpg";